import { noop } from 'lodash';
import React from 'react';

import type { PokerContext } from '@swf/core/types/Poker';
import type { HgClubInfo } from '@swf/generated/types/api/v0/SwHomeGames';

export interface TournamentContextState {
  activePage: number;
  clubs: HgClubInfo[];
  clubId: number;
  title: string;
  isRecurrenceOpen: boolean;
  fetchService: PokerContext['fetchService'];
}

export interface ContextProvider {
  state: TournamentContextState;
  setState: React.Dispatch<React.SetStateAction<TournamentContextState>>;
}

const CreateTournamentContext = React.createContext<ContextProvider>({
  state: {
    activePage: 0,
    clubs: [],
    clubId: 0,
    title: '',
    isRecurrenceOpen: false,
    fetchService: () => Promise.resolve('')
  },
  setState: () => noop
});

export default CreateTournamentContext;
